const initialStateStatus = {
    status: [],
    status_updated: false,
};

export default initialStateStatus;